import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { LayoutService } from "./service/app.layout.service";
import { TourService } from "../site/service/tour.service";
import { DocumentsNotificationService } from "../site/service/documents-notification.service";

@Component({
  standalone: false,
  selector: "app-sidebar",
  templateUrl: "./app.sidebar.component.html",
})
export class AppSidebarComponent implements OnInit {
  timeout: any = null;

  @ViewChild("menuContainer") menuContainer!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
    private tourService: TourService,
    private documentsNotificationService: DocumentsNotificationService,
  ) {}

  ngOnInit(): void {
    // Populate the Documents nav badge with the pending-review count on load.
    void this.documentsNotificationService.refresh();
  }

  startTutorial() {
    void this.tourService.start();
  }

  onMouseEnter() {
    if (!this.layoutService.state.anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.layoutService.state.sidebarActive = true;
    }
  }

  onMouseLeave() {
    if (!this.layoutService.state.anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(
          () => (this.layoutService.state.sidebarActive = false),
          300,
        );
      }
    }
  }

  anchor() {
    this.layoutService.state.anchored = !this.layoutService.state.anchored;
  }
}
